import { Component, OnInit, AfterViewInit, Injectable } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
declare var $: any;
declare var Mmenu:any;
declare var window : any;
declare var document:any; 
declare function loadMobileMenu():any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit,AfterViewInit {

  constructor(public commonService: CommonService) {

   }
 
  ngOnInit() {
  }

  

  ngAfterViewInit() {
    if(this.commonService.iMobBroswer())
    {     
           $(document).ready(function(){
            // Fire the plugin
            const menu = new Mmenu("#mmenu", {
                extensions: ["position-bottom", "fullscreen", "theme-black", "border-full"],
                
                navbars		: [
                   // {
                   // height 	: 2
                   // }, 
                   {
                   content : ["prev","title"]
                   },
                   {
                   position: "bottom",
                   content: [
                     '<a href="tel:18885436179" class="telNum"><i class="fas fa-phone"></i></a>',
                     '<a href="mailto:Contactus@Westwoodins.com" class="emailUs pl-5"><i class="fas fa-envelope"></i></a>',
                     "<a href='"+window.location.origin+"/get-a-quote'>Get A Quote</a>"
                   ]
                 }
               ]
             });
             // Get the API
             const api = menu.API;
             console.log(api)
             api.bind("openPanel:start",
               (panel) => {
                // console.log("Started opening panel: " + panel.id);
               }
             );
             api.bind("openPanel:finish",
               (panel) => {
                // console.log("Finished opening panel: " + panel.id);
               }
             );
             api.bind("setSelected:before",
               (panel) => {
                // console.log("Started opening panel: " + panel.id);
               }
             );
             api.bind("setSelected:after",
               (panel) => {
                 api.closeAllPanels();
                 api.close();
                // console.log("Finished opening panel: " + panel.id);
               }
             );

             var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

             if (!isIE11) {
               $(".mh-head.Sticky").mhead({
                       scroll: {
                           hide: 200
                       }
                   });
           
                   $(".mh-head:not(.Sticky)").mhead({
                       scroll: false
                   });
               }
       });
    //loadMobileMenu();
    }
  }
}



